import { FC, ReactNode } from 'react';

import { Link, rem } from '@bonusly/design-system';

type UserNavLinkExternalProps = {
	children: ReactNode;
	href?: string;
	onClick?: () => void;
};

export const UserNavLinkExternal: FC<UserNavLinkExternalProps> = ({ children, href, onClick, ...props }) => {
	return (
		<Link
			{...(href ? { href } : { as: 'button', onClick, textAlign: 'left' })}
			display="block"
			w="100%"
			py={rem(8)}
			px={rem(10)}
			borderRadius="md"
			_hover={{ bg: 'secondary.bgAlpha', textDecoration: 'none' }}
			{...props}
		>
			{children}
		</Link>
	);
};
